import {
  CreateReviewMemberInvite,
  DeleteReviewMemberInvite,
} from '@/graphql';
import { apolloClient } from '@/plugins/apollo';

const actions = {
  async createReviewMemberInvite(context, reviewMemberInvite) {
    const response = await apolloClient.mutate({
      mutation: CreateReviewMemberInvite,
      variables: { reviewMemberInvite },
      update: (cache, { data }) => {
        if (data.createReviewMemberInvite) {
          cache.modify({
            id: cache.identify({
              id: reviewMemberInvite.review,
              __typename: 'Review',
            }),
            fields: {
              invites(existingInvites, { toReference }) {
                return [
                  ...existingInvites,
                  toReference(data.createReviewMemberInvite),
                ];
              },
            },
          });
        }
      },
    });
    // Refetch if the user already existed in the system.
    if (!response.data.createReviewMemberInvite) {
      apolloClient.refetchQueries({
        include: ['GetReviewForSettingsPage'],
      });
    }
  },
  async deleteReviewMemberInvite(context, reviewMemberInvite) {
    const request = {
      mutation: DeleteReviewMemberInvite,
      variables: { id: reviewMemberInvite.id },
      optimisticResponse: {
        deleteReviewMemberInvite: null,
      },
      update: (cache) => {
        cache.modify({
          id: cache.identify(reviewMemberInvite.review),
          fields: {
            invites(existingInvites, { readField }) {
              return existingInvites?.filter(
                (ref) =>
                  readField('id', ref) !== reviewMemberInvite.id
              );
            },
          },
        });
      },
    };
    await apolloClient.mutate(request);
  },
};

const state = {};

const mutations = {};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
};
